/* SnugBugs bundle deal selector: Single / Buy 2 (15% off) / Buy 3 (20% off) + matching essentials.
   Discounts are applied at checkout by Shopify automatic discounts on the "bundle-deals" collection. */
(function () {
  'use strict';
  if (window.SBDeal) { window.SBDeal.initAll(); return; }

  var instances = [];
  var TIERS = [
    { qty: 1, off: 0 },
    { qty: 2, off: 15, badge: 'Save 15%' },
    { qty: 3, off: 20, badge: 'Best Value', accent: true }
  ];

  // Matching essentials get this % off at checkout when bought with a bundle-deal item
  // (Shopify automatic Buy X Get Y discount "Matching Essentials – Extra 5% Off With a Bra or Set").
  var ESS_OFF = 5;
  function addonPrice(cents) { return Math.round(cents * (100 - ESS_OFF) / 100); }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents, format) {
    var amount = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || 'Rs.{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function Deal(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-sb-config]').textContent);
    this.formId = root.getAttribute('data-form-id');
    this.qty = 1;
    this.rows = [];
    this.essentials = [];
    this.variantMap = {};
    var self = this;
    this.cfg.product.variants.forEach(function (v) { self.variantMap[v.id] = v; });
    this.build();
    root.hidden = false;
    root.setAttribute('data-sb-ready', 'true');
  }

  Deal.prototype.form = function () {
    return document.getElementById(this.formId);
  };

  Deal.prototype.baseVariant = function () {
    var form = this.form();
    var input = form && form.querySelector('[name="id"]');
    var v = input && this.variantMap[Number(input.value)];
    if (v) return v;
    var variants = this.cfg.product.variants;
    for (var i = 0; i < variants.length; i++) if (variants[i].available) return variants[i];
    return variants[0];
  };

  Deal.prototype.findVariant = function (values) {
    var variants = this.cfg.product.variants;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { match = false; break; }
      if (match) return v;
    }
    return null;
  };

  Deal.prototype.build = function () {
    var self = this, cfg = this.cfg;
    var heading = el('p', 'sb-deal__heading', 'Select your deal');
    this.cardsEl = el('div', 'sb-deal__cards');
    this.cardsEl.setAttribute('role', 'radiogroup');
    this.cardsEl.setAttribute('aria-label', 'Select your deal');
    this.cards = [];

    TIERS.forEach(function (tier) {
      var card = el('div', 'sb-deal__card');
      card.setAttribute('role', 'radio');
      card.setAttribute('tabindex', '0');
      card.dataset.qty = tier.qty;
      if (tier.badge) card.appendChild(el('span', 'sb-deal__badge' + (tier.accent ? ' sb-deal__badge--accent' : ''), tier.badge));

      var head = el('div', 'sb-deal__head');
      head.appendChild(el('span', 'sb-deal__radio'));
      var info = el('div', 'sb-deal__info');
      var title = el('span', 'sb-deal__title', tier.qty === 1 ? 'Single' : 'Buy ' + tier.qty + ' ' + cfg.word);
      if (tier.off) title.appendChild(el('span', 'sb-deal__pill', tier.off + '% OFF'));
      info.appendChild(title);
      info.appendChild(el('span', 'sb-deal__sub', tier.qty === 1 ? '🍫 Cute free treat included' : 'Mix colours & sizes · 🍫 Free treat'));
      head.appendChild(info);
      var price = el('div', 'sb-deal__price');
      var now = el('span', 'sb-deal__now');
      price.appendChild(now);
      var was = null;
      if (tier.off) { was = el('span', 'sb-deal__was'); price.appendChild(was); }
      head.appendChild(price);
      card.appendChild(head);

      var rows = null;
      if (tier.qty > 1) {
        rows = el('div', 'sb-deal__rows');
        rows.hidden = true;
        rows.addEventListener('click', function (e) { e.stopPropagation(); });
        rows.addEventListener('keydown', function (e) { e.stopPropagation(); });
        card.appendChild(rows);
      }

      card.addEventListener('click', function () { self.select(tier.qty); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.select(tier.qty); }
      });
      self.cardsEl.appendChild(card);
      self.cards.push({ tier: tier, card: card, now: now, was: was, rows: rows });
    });

    this.summary = el('div', 'sb-deal__summary');
    this.summary.hidden = true;

    this.root.appendChild(heading);
    this.root.appendChild(this.cardsEl);
    this.root.appendChild(this.summary);
    this.buildEssentials();
    this.errorEl = el('p', 'sb-deal__error');
    this.errorEl.setAttribute('role', 'alert');
    this.errorEl.hidden = true;
    this.root.appendChild(this.errorEl);

    this.buyNow = el('button', 'sb-deal__buynow', 'Buy it now');
    this.buyNow.type = 'button';
    this.buyNow.hidden = true;
    this.buyNow.addEventListener('click', function () { self.add(true); });
    var form = this.form();
    var buttons = form && form.querySelector('.product-form__buttons');
    (buttons || this.root).appendChild(this.buyNow);

    this.select(1);
  };

  Deal.prototype.buildEssentials = function () {
    var self = this, cfg = this.cfg;
    var list = (cfg.essentials || []).filter(function (p) {
      return p.variants.some(function (v) { return v.available; });
    });
    if (!list.length) return;
    var wrap = el('div', 'sb-deal__ess');
    wrap.appendChild(el('p', 'sb-deal__ess-heading', 'Add matching essentials'));
    var listEl = el('div', 'sb-deal__ess-list');

    list.forEach(function (p, idx) {
      var available = p.variants.filter(function (v) { return v.available; });
      var item = el('div', 'sb-deal__ess-item');
      var label = el('label', 'sb-deal__ess-main');
      var check = el('input', 'sb-deal__ess-check');
      check.type = 'checkbox';
      check.id = self.formId + '-sb-ess-' + idx;
      label.setAttribute('for', check.id);
      label.appendChild(check);
      if (p.image) {
        var img = el('img', 'sb-deal__ess-img');
        img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 52; img.height = 52;
        label.appendChild(img);
      }
      var text = el('span', 'sb-deal__ess-text');
      text.appendChild(el('span', 'sb-deal__ess-title', p.title));
      text.appendChild(el('span', 'sb-deal__ess-sub', 'Extra ' + ESS_OFF + '% off with this deal'));
      label.appendChild(text);
      var prices = el('span', 'sb-deal__ess-prices');
      var priceEl = el('span', 'sb-deal__ess-price');
      var wasEl = el('span', 'sb-deal__ess-was');
      prices.appendChild(priceEl);
      prices.appendChild(wasEl);
      label.appendChild(prices);
      item.appendChild(label);
      function showPrice(v) {
        priceEl.textContent = money(addonPrice(v.price), cfg.moneyFormat);
        wasEl.textContent = money(Math.max(v.compare || 0, v.price), cfg.moneyFormat);
      }
      showPrice(available[0]);

      var entry = { product: p, check: check, item: item, select: null, variant: available[0] };
      if (available.length > 1) {
        var select = el('select', 'sb-deal__select sb-deal__ess-variant');
        select.setAttribute('aria-label', 'Choose option for ' + p.title);
        available.forEach(function (v) {
          var opt = el('option', null, v.title);
          opt.value = v.id;
          select.appendChild(opt);
        });
        select.hidden = true;
        select.addEventListener('change', function () {
          for (var i = 0; i < available.length; i++) if (String(available[i].id) === select.value) entry.variant = available[i];
          showPrice(entry.variant);
          self.update();
        });
        item.appendChild(select);
        entry.select = select;
      }
      check.addEventListener('change', function () {
        item.classList.toggle('is-checked', check.checked);
        if (entry.select) entry.select.hidden = !check.checked;
        self.update();
      });
      self.essentials.push(entry);
      listEl.appendChild(item);
    });
    wrap.appendChild(listEl);
    this.root.appendChild(wrap);
  };

  Deal.prototype.select = function (qty) {
    var self = this;
    var fromSingle = this.qty === 1;
    this.qty = qty;
    var base = this.baseVariant();
    if (qty > 1) {
      var rows = [];
      for (var i = 0; i < qty; i++) {
        if (i === 0 && fromSingle) rows.push(base.options.slice());
        else rows.push(this.rows[i] ? this.rows[i].slice() : base.options.slice());
      }
      this.rows = rows;
    }
    this.cards.forEach(function (c) {
      var on = c.tier.qty === qty;
      c.card.classList.toggle('is-selected', on);
      c.card.setAttribute('aria-checked', on ? 'true' : 'false');
      if (c.rows) {
        c.rows.hidden = !on;
        if (on) self.renderRows(c.rows);
        else c.rows.innerHTML = '';
      }
    });
    this.toggleThemeControls(qty > 1);
    this.update();
  };

  Deal.prototype.renderRows = function (container) {
    var self = this, product = this.cfg.product;
    container.innerHTML = '';
    if (product.hasOnlyDefault) {
      container.appendChild(el('p', 'sb-deal__rows-label', this.qty + ' × same item, added together.'));
      return;
    }
    var names = product.options.map(function (o) { return o.name; }).join(', ');
    container.appendChild(el('p', 'sb-deal__rows-label', 'Choose ' + names.toLowerCase() + ' for each:'));
    this.rowNotes = [];
    this.rows.forEach(function (values, r) {
      var wrapRow = el('div', 'sb-deal__row-wrap');
      var row = el('div', 'sb-deal__row');
      row.appendChild(el('span', 'sb-deal__row-num', (r + 1) + '.'));
      var selects = el('div', 'sb-deal__row-selects');
      product.options.forEach(function (option, o) {
        var select = el('select', 'sb-deal__select');
        select.setAttribute('aria-label', option.name + ' for item ' + (r + 1));
        option.values.forEach(function (val) {
          var opt = el('option', null, val);
          opt.value = val;
          if (val === values[o]) opt.selected = true;
          select.appendChild(opt);
        });
        select.addEventListener('change', function () {
          self.rows[r][o] = select.value;
          self.update();
        });
        selects.appendChild(select);
      });
      row.appendChild(selects);
      wrapRow.appendChild(row);
      var note = el('p', 'sb-deal__row-note');
      note.hidden = true;
      wrapRow.appendChild(note);
      self.rowNotes.push(note);
      container.appendChild(wrapRow);
    });
  };

  Deal.prototype.toggleThemeControls = function (hide) {
    var scope = this.root.closest('.product') || this.root.closest('section') || document;
    var nodes = scope.querySelectorAll('variant-radios, variant-selects, .product-form__quantity');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.toggle('sb-deal-hidden', hide);
  };

  Deal.prototype.essentialsTotal = function () {
    var sum = 0;
    this.essentials.forEach(function (e) { if (e.check.checked) sum += addonPrice(e.variant.price); });
    return sum;
  };

  Deal.prototype.essentialsSaving = function () {
    var sum = 0;
    this.essentials.forEach(function (e) { if (e.check.checked) sum += e.variant.price - addonPrice(e.variant.price); });
    return sum;
  };

  Deal.prototype.active = function () {
    return this.qty > 1 || this.essentials.some(function (e) { return e.check.checked; });
  };

  Deal.prototype.update = function () {
    var self = this, fmt = this.cfg.moneyFormat, base = this.baseVariant();
    var dealNow = 0, dealWas = 0;
    if (this.errorEl) this.showError('');
    this.cards.forEach(function (c) {
      var full = 0;
      if (c.tier.qty === self.qty && self.qty > 1) {
        self.rows.forEach(function (values, r) {
          var v = self.findVariant(values);
          var ok = v && v.available;
          if (self.rowNotes && self.rowNotes[r]) {
            self.rowNotes[r].hidden = !!ok;
            self.rowNotes[r].textContent = ok ? '' : 'This combination is not available, please choose another.';
          }
          full += (v || base).price;
        });
      } else {
        full = base.price * c.tier.qty;
      }
      var now = Math.round(full * (100 - c.tier.off) / 100);
      c.now.textContent = money(now, fmt);
      if (c.was) c.was.textContent = money(full, fmt);
      if (c.tier.qty === self.qty) { dealNow = now; dealWas = full; }
    });

    var ess = this.essentialsTotal();
    if (this.active()) {
      this.summary.hidden = false;
      this.summary.innerHTML = '';
      var left = el('span');
      left.appendChild(document.createTextNode('Your total: '));
      left.appendChild(el('strong', null, money(dealNow + ess, fmt)));
      this.summary.appendChild(left);
      var saving = (dealWas - dealNow) + this.essentialsSaving();
      if (saving > 0) this.summary.appendChild(el('span', 'sb-deal__save', 'You save ' + money(saving, fmt)));
    } else {
      this.summary.hidden = true;
    }
    this.syncBuyButtons();
  };

  Deal.prototype.syncBuyButtons = function () {
    var form = this.form();
    var active = this.active();
    var scope = (form && form.closest('product-form')) || form || document;
    var pay = scope.querySelectorAll('.shopify-payment-button');
    for (var i = 0; i < pay.length; i++) pay[i].classList.toggle('sb-deal-hidden', active);
    this.buyNow.hidden = !active;
  };

  Deal.prototype.showError = function (msg) {
    this.errorEl.textContent = msg;
    this.errorEl.hidden = !msg;
  };

  Deal.prototype.buildItems = function () {
    var items = [];
    if (this.qty > 1) {
      var counts = {}, order = [];
      for (var r = 0; r < this.rows.length; r++) {
        var v = this.cfg.product.hasOnlyDefault ? this.cfg.product.variants[0] : this.findVariant(this.rows[r]);
        if (!v || !v.available) {
          this.showError('Item ' + (r + 1) + ': this combination is not available. Please choose another colour or size.');
          return null;
        }
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += 1;
      }
      order.forEach(function (id) { items.push({ id: id, quantity: counts[id] }); });
    } else {
      var base = this.baseVariant();
      if (!base || !base.available) { this.showError('Please choose an available size first.'); return null; }
      var qtyInput = document.querySelector('[name="quantity"][form="' + this.formId + '"]') ||
        (this.form() && this.form().querySelector('[name="quantity"]'));
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      items.push({ id: base.id, quantity: q });
    }
    this.essentials.forEach(function (e) { if (e.check.checked) items.push({ id: e.variant.id, quantity: 1 }); });
    return items;
  };

  Deal.prototype.setBusy = function (busy) {
    var form = this.form();
    var btn = form && form.querySelector('[type="submit"]');
    var spinner = form && form.querySelector('.loading__spinner');
    if (btn) {
      btn.classList.toggle('loading', busy);
      if (busy) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
    }
    if (spinner) spinner.classList.toggle('hidden', !busy);
    this.buyNow.setAttribute('aria-busy', busy ? 'true' : 'false');
    this.buyNow.disabled = busy;
  };

  Deal.prototype.add = function (goCheckout) {
    var self = this;
    this.showError('');
    var items = this.buildItems();
    if (!items) return;
    var cart = document.querySelector('cart-drawer');
    var body = { items: items };
    if (!goCheckout && cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    this.setBusy(true);
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        if (res.status) {
          self.showError(res.description || res.message || 'Could not add to cart. Please try again.');
          return;
        }
        if (goCheckout) { window.location.href = rootUrl() + 'checkout'; return; }
        if (cart && res.sections && typeof cart.renderContents === 'function') {
          try {
            cart.renderContents(res);
            cart.classList.remove('is-empty');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb-deal', cartData: res });
            }
            return;
          } catch (err) { console.error(err); }
        }
        window.location.href = (window.routes && window.routes.cart_url) || rootUrl() + 'cart';
      })
      .catch(function () { self.showError('Something went wrong. Please try again.'); })
      .then(function () { self.setBusy(false); });
  };

  Deal.prototype.ownsForm = function (form) {
    if (form.id && form.id === this.formId) return true;
    var input = form.querySelector('[name="id"]');
    return !!(input && this.variantMap[Number(input.value)]);
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!inst.root.isConnected || !inst.ownsForm(form)) continue;
      if (inst.active()) {
        e.preventDefault();
        e.stopPropagation();
        inst.add(false);
      }
      return;
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-radios, variant-selects')) return;
    setTimeout(function () {
      instances.forEach(function (inst) { if (inst.root.isConnected && inst.qty === 1) inst.update(); });
    }, 80);
  });

  function initAll() {
    var roots = document.querySelectorAll('[data-sb-deal]:not([data-sb-ready])');
    for (var i = 0; i < roots.length; i++) {
      try { instances.push(new Deal(roots[i])); } catch (err) { console.error('SBDeal init failed', err); }
    }
  }

  window.SBDeal = { initAll: initAll, instances: instances };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
